export type ProductQuantityInputValue = 'empty' | 'invalid' | number;

export const isEmptyProductQuantityInput = (value: string | number | undefined | null): boolean => {
    return value === '' || value === undefined || value === null;
};

export const isIntegerProductQuantityInput = (value: string | number | undefined | null): boolean => {
    if (isEmptyProductQuantityInput(value)) {
        return true;
    }
    return /^\d+$/.test(String(value).trim());
};

export const toProductQuantityInputValue = (
    value: string | number | undefined | null
): ProductQuantityInputValue => {
    if (isEmptyProductQuantityInput(value)) {
        return 'empty';
    }
    if (!isIntegerProductQuantityInput(value)) {
        return 'invalid';
    }
    return parseInt(String(value).trim(), 10);
};

export const shouldApplyProductQuantityInput = (inputValue: ProductQuantityInputValue): inputValue is number => {
    return typeof inputValue === 'number' && inputValue > 0;
};

export const shouldApplyNonNegativeProductQuantityInput = (
    inputValue: ProductQuantityInputValue
): inputValue is number => {
    return typeof inputValue === 'number' && inputValue >= 0;
};

export const shouldRestoreProductQuantityOnBlur = (lastValue: ProductQuantityInputValue): boolean => {
    return lastValue === 'empty' || lastValue === 'invalid' || lastValue === 0;
};

export const shouldRestoreNonNegativeProductQuantityOnBlur = (
    lastValue: ProductQuantityInputValue
): boolean => {
    return lastValue === 'empty' || lastValue === 'invalid';
};

export const parseProductQuantityValue = (value: string | number | undefined | null): number => {
    const inputValue = toProductQuantityInputValue(value);
    if (typeof inputValue !== 'number') {
        return 0;
    }
    return inputValue;
};
